import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import { xhrDefaultMessage } from "../../config/notification";
import { createAppAsyncThunk } from "../appAsyncThunk";
import { ConfirmResetPassword } from "./types";

export const resetPasswordThunk = createAppAsyncThunk(
    'forgetPassword/resetPasswordThunk', async (username: string, { rejectWithValue }) => {
        try {
            const response = await resetPassword({ username });
            return response;
        } catch (e: unknown) {
            const message = e instanceof Error ? e.message : xhrDefaultMessage;
            return rejectWithValue(message);
        }
    });

export const confirmResetPasswordThunk = createAppAsyncThunk(
    'forgetPassword/confirmResetPasswordThunk', async (body: ConfirmResetPassword, { rejectWithValue }) => {
        try {
            const { username, confirmationCode, newPassword } = body;
            const response = await confirmResetPassword({ username, confirmationCode, newPassword });
            return response;
        } catch (e: unknown) {
            const message = e instanceof Error ? e.message : xhrDefaultMessage;
            return rejectWithValue(message);
        }
    });